import { render, staticRenderFns } from "./BlockImage.vue?vue&type=template&id=5e6cb4e8&"
import script from "./BlockImage.vue?vue&type=script&lang=js&"
export * from "./BlockImage.vue?vue&type=script&lang=js&"
import style0 from "./BlockImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports